import { createSlice } from "@reduxjs/toolkit";
import {
  postLoginSignupOtpRepo,
  getUserAuthenticationpRepo,
  getManageContentRepo,
  getIpAddressRepo,
  getGeoLocationRepo,
  getGpsLocationRepo,
  postLoginDataRepo,
  getCtaMessagingRepo,
  postUpdateProfileRepo,
  getSignupFieldsDropdownRepo,
  getUserInfoRepo,
  postUserProfileClevertapRepo,
  getOneClickLoginUserCheckRepo,
  getUserAccountLimitRepo
} from "../../repositories/Registration/index";

const UserCommonSlice = createSlice({
  name: "userCommonReducer",
  initialState: {
    userLoginSignupOtpLoading: false,
    userLoginSignupOtp: null,
    userDirectToOtpScreen: false,
    userAuthenticatedForOtp: false,
    userLoginSignupOtpError: null,
    userAuthenticationLoading: false,
    userAuthentication: null,
    userAuthenticationError: null,
    manageContentLoading: false,
    manageContent: null,
    manageContentError: null,
    userIpLoading: false,
    userIp: null,
    userIpError: null,
    geoLocationLoading: false,
    geoLocation: null,
    geoLocationError: null,
    gpsLocationLoading: false,
    gpsLocation: null,
    gpsLocationError: null,
    loginDataLoading: false,
    loginData: null,
    loginDataError: null,
    ctaMessagingLoading: false,
    ctaMessaging: null,
    ctaMessagingError: null,
    updateProfileLoading: false,
    updateProfile: null,
    updateProfileError: null,
    emailDomainDataLoading: false,
    emailDomainData: null,
    emailDomainDataError: null,
    countryCodeLoading: false,
    countryCode: null,
    countryCodeError: null,
    userInfoLoading: false,
    userInfo: null,
    userInfoError: null,
    userAuthenticationEmailLoading: false,
    userAuthenticationEmail: null,
    userAuthenticationEmailError: null,
    userProfileClevertapLoading: false,
    userProfileClevertap: null,
    userProfileClevertapFailure: null,
    oneClickLoginUserCheckLoading: false,
    oneClickLoginUserCheck: null,
    oneClickLoginUserCheckError: null,
    userAccountLimitLoading: false,
    userAccountLimit: null,
    userAccountLimitError: null
  },
  reducers: {
    postUserLoginSignupOtpLoading(state, action) {
      return {
        ...state,
        userLoginSignupOtpLoading: true,
      };
    },
    makeOtpScreenProhibited(state, action) {
      return {
        ...state,
        userDirectToOtpScreen: false,
      }
    },
    makeUserAuthenticateProhibited(state, action) {
      return {
        ...state,
        userAuthenticatedForOtp: false,
      }
    },
    postUserLoginSignupOtpSuccess(state, action) {
      return {
        ...state,
        userLoginSignupOtpLoading: false,
        userLoginSignupOtp: action.payload,
        userLoginSignupOtpError: null,
        userDirectToOtpScreen: true,
      };
    },
    postUserLoginSignupOtpFailure(state, action) {
      return {
        ...state,
        userLoginSignupOtpLoading: false,
        userLoginSignupOtpError: action.payload,
        userDirectToOtpScreen: false,
        userLoginSignupOtp: null,
        userAuthenticationEmail: null, // done to clear email authentication while otp verification on signup.
      };
    },

    clearUserLoginSignupOtpResponse(state, action) {
      return {
        ...state,
        userLoginSignupOtp: null,
        userLoginSignupOtpError: null,
      };
    },
    getUserAuthenticationLoading(state, action) {
      return {
        ...state,
        userAuthenticationLoading: true,
      };
    },
    getUserAuthenticationSuccess(state, action) {
      return {
        ...state,
        userAuthenticationLoading: false,
        userAuthentication: action.payload,
        userAuthenticatedForOtp:true,
        userAuthenticationError: null,
      };
    },
    getUserAuthenticationFailure(state, action) {
      return {
        ...state,
        userAuthenticationLoading: false,
        userAuthenticationError: action.payload,
        userAuthentication: null,
        userAuthenticatedForOtp:false,
        userLoginSignupOtp: null     //done for otp verification purpose - showing errors.
      };
    },
    clearUserAuthenticationResponse(state, action) {
      return {
        ...state,
        userAuthentication: null,
        userAuthenticationError: null,
      };
    },
    getManageContentLoading(state, action) {
      return {
        ...state,
        manageContentLoading: true,
      };
    },
    getManageContentSuccess(state, action) {
      return {
        ...state,
        manageContentLoading: false,
        manageContent: action.payload,
      };
    },
    getManageContentFailure(state, action) {
      return {
        ...state,
        manageContentLoading: false,
        manageContentError: action.payload,
      };
    },
    clearManageContentResponse(state, action) {
      return {
        ...state,
        manageContent: null,
      };
    },
    getUserIpLoading(state, action) {
      return {
        ...state,
        userIpLoading: true,
      };
    },
    getUserIpSuccess(state, action) {
      return {
        ...state,
        userIpLoading: false,
        userIp: action.payload,
      };
    },
    getUserIpFailure(state, action) {
      return {
        ...state,
        userIpLoading: false,
        userIpError: action.payload,
      };
    },
    clearUserIpResponse(state, action) {
      return {
        ...state,
        userIp: null,
      };
    },
    getGeoLocationLoading(state, action) {
      return {
        ...state,
        geoLocationLoading: true,
      };
    },
    getGeoLocationSuccess(state, action) {
      return {
        ...state,
        geoLocationLoading: false,
        geoLocation: action.payload,
      };
    },
    getGeoLocationFailure(state, action) {
      return {
        ...state,
        geoLocationLoading: false,
        geoLocationError: action.payload,
      };
    },
    clearGeoLocationResponse(state, action) {
      return {
        ...state,
        geoLocation: null,
      };
    },
    getGpsLocationLoading(state, action) {
      return {
        ...state,
        gpsLocationLoading: true,
        gpsLocationError: null,
      };
    },
    getGpsLocationSuccess(state, action) {
      return {
        ...state,
        gpsLocationLoading: false,
        gpsLocation: action.payload,
        gpsLocationError: null,
      };
    },
    getGpsLocationFailure(state, action) {
      return {
        ...state,
        gpsLocationLoading: false,
        gpsLocationError: action.payload,
      };
    },
    clearGpsLocationResponse(state, action) {
      return {
        ...state,
        gpsLocation: null,
        gpsLocationError: null,
      };
    },
    postLoginDataLoading(state, action) {
      return {
        ...state,
        loginDataLoading: true,
        // loginData: null,
        loginDataError: null,
      };
    },
    postLoginDataSuccess(state, action) {
      return {
        ...state,
        loginDataLoading: false,
        loginData: action.payload,
        loginDataError: null,
      };
    },
    postLoginDataFailure(state, action) {
      return {
        ...state,
        loginDataLoading: false,
        loginDataError: action.payload,
      };
    },
    clearLoginDataResponse(state, action) {
      return {
        ...state,
        loginData: null,
        loginDataError: null,
      };
    },
    getCtaMessagingLoading(state, action) {
      return {
        ...state,
        ctaMessagingLoading: true,
      };
    },
    getCtaMessagingSuccess(state, action) {
      return {
        ...state,
        ctaMessagingLoading: false,
        ctaMessaging: action.payload,
      };
    },
    getCtaMessagingFailure(state, action) {
      return {
        ...state,
        ctaMessagingLoading: false,
        ctaMessagingError: action.payload,
      };
    },
    postUpdateProfileLoading(state, action) {
      return {
        ...state,
        updateProfileLoading: true,
      };
    },
    postUpdateProfileSuccess(state, action) {
      return {
        ...state,
        updateProfileLoading: false,
        updateProfile: action.payload,
      };
    },
    postUpdateProfileFailure(state, action) {
      return {
        ...state,
        updateProfileLoading: false,
        updateProfileError: action.payload,
      };
    },
    clearUpdateProfileResponse(state, action) {
      return {
        ...state,
        updateProfile: null,
      };
    },
    getEmailDomainDataLoading(state, action) {
      return {
        ...state,
        emailDomainDataLoading: true,
      };
    },
    getEmailDomainDataSuccess(state, action) {
      return {
        ...state,
        emailDomainDataLoading: false,
        emailDomainData: action.payload,
      };
    },
    getEmailDomainDataFailure(state, action) {
      return {
        ...state,
        emailDomainDataLoading: false,
        emailDomainDataError: action.payload,
      };
    },
    getCountryCodeDataLoading(state, action) {
      return {
        ...state,
        countryCodeLoading: true,
      };
    },
    getCountryCodeDataSuccess(state, action) {
      return {
        ...state,
        countryCodeLoading: false,
        countryCode: action.payload,
        countryCodeError: null,
      };
    },
    getCountryCodeDataFailure(state, action) {
      return {
        ...state,
        countryCodeLoading: false,
        countryCodeError: action.payload,
      };
    },
    getUserInfoLoading(state, action) {
      return {
        ...state,
        userInfoLoading: true,
      };
    },
    getUserInfoSuccess(state, action) {
      return {
        ...state,
        userInfoLoading: false,
        userInfo: action.payload,
        userInfoError: null,
      };
    },
    getUserInfoFailure(state, action) {
      return {
        ...state,
        userInfoLoading: false,
        userInfoError: action.payload,
      }
    },
    getUserAuthenticationEmailLoading(state, action) {
      return {
        ...state,
        userAuthenticationEmailLoading: true,
      };
    },
    getUserAuthenticationEmailSuccess(state, action) {
      return {
        ...state,
        userAuthenticationEmailLoading: false,
        userAuthenticationEmail: action.payload,
        userAuthenticationEmailError: null,
        userLoginSignupOtpError: null,
      };
    },
    getUserAuthenticationEmailFailure(state, action) {
      return {
        ...state,
        userAuthenticationEmailLoading: false,
        userAuthenticationEmailError: action.payload,
        userAuthenticationEmail: null,
        userLoginSignupOtp: null     //done for otp verification purpose - showing errors.
      };
    },
    clearUserAuthenticationEmailResponse(state, action) {
      return {
        ...state,
        userAuthenticationEmail: null,
        userAuthenticationEmailError: null,
      };
    },
    postClevertapUserProfileLoading(state, action){
      return{
        ...state,
        userProfileClevertapLoading: true,
        userProfileClevertap: null,
        userProfileClevertapFailure: null
      }
    },
    postClevertapUserProfileSuccess(state, action){
      return{
        ...state,
        userProfileClevertapLoading: false,
        userProfileClevertap: action.payload,
        userProfileClevertapFailure: null
      }
    },
    postClevertapUserProfileFailure(state, action){
      return{
        ...state,
        userProfileClevertapLoading: false,
        userProfileClevertap: null,
        userProfileClevertapFailure: action.payload
      }
    },
    getOneClickLoginUserCheckLoading(state, action) {
      return {
        ...state,
        oneClickLoginUserCheckLoading: true,
      };
    },
    getOneClickLoginUserCheckSuccess(state, action) {
      return {
        ...state,
        oneClickLoginUserCheckLoading: false,
        oneClickLoginUserCheck: action.payload,
        oneClickLoginUserCheckError: null,
      };
    },
    getOneClickLoginUserCheckFailure(state, action) {
      return {
        ...state,
        oneClickLoginUserCheckLoading: false,
        oneClickLoginUserCheckError: action.payload,
        oneClickLoginUserCheck: null,
      };
    },
    clearOneClickLoginUserCheckResponse(state, action) {
      return {
        ...state,
        oneClickLoginUserCheck: null,
        oneClickLoginUserCheckError: null,
      };
    },

    getUserAccountLimitCheckLoading(state, action) {
      return {
        ...state,
        userAccountLimitLoading: true,
      };
    },
    getUserAccountLimitCheckSuccess(state, action) {
      return {
        ...state,
        userAccountLimitLoading: false,
        userAccountLimit: action.payload,
        userAccountLimitError: null,
      };
    },
    getUserAccountLimitCheckFailure(state, action) {
      return {
        ...state,
        userAccountLimitLoading: false,
        userAccountLimitError: action.payload,
        userAccountLimit: null,
      };
    },
    clearUserAccountLimitCheck(state, action) {
      return {
        ...state,
        userAccountLimit: null,
        userAccountLimitError: null,
      };
    },
  },
});

export const {
  postUserLoginSignupOtpLoading,
  postUserLoginSignupOtpSuccess,
  postUserLoginSignupOtpFailure,
  clearUserLoginSignupOtpResponse,
  getUserAuthenticationLoading,
  getUserAuthenticationSuccess,
  getUserAuthenticationFailure,
  clearUserAuthenticationResponse,
  getManageContentLoading,
  getManageContentSuccess,
  getManageContentFailure,
  clearManageContentResponse,
  getUserIpLoading,
  getUserIpSuccess,
  getUserIpFailure,
  clearUserIpResponse,
  getGeoLocationLoading,
  getGeoLocationSuccess,
  getGeoLocationFailure,
  clearGeoLocationResponse,
  getGpsLocationLoading,
  getGpsLocationSuccess,
  getGpsLocationFailure,
  clearGpsLocationResponse,
  postLoginDataLoading,
  postLoginDataSuccess,
  postLoginDataFailure,
  clearLoginDataResponse,
  getCtaMessagingLoading,
  getCtaMessagingSuccess,
  getCtaMessagingFailure,
  postUpdateProfileLoading,
  postUpdateProfileSuccess,
  postUpdateProfileFailure,
  clearUpdateProfileResponse,
  getEmailDomainDataLoading,
  getEmailDomainDataSuccess,
  getEmailDomainDataFailure,
  getCountryCodeDataLoading,
  getCountryCodeDataSuccess,
  getCountryCodeDataFailure,
  getUserInfoLoading,
  getUserInfoSuccess,
  getUserInfoFailure,
  getUserAuthenticationEmailLoading,
  getUserAuthenticationEmailSuccess,
  getUserAuthenticationEmailFailure,
  clearUserAuthenticationEmailResponse,
  makeOtpScreenProhibited,
  makeUserAuthenticateProhibited,
  postClevertapUserProfileLoading,
  postClevertapUserProfileSuccess,
  postClevertapUserProfileFailure,
  getOneClickLoginUserCheckLoading,
  getOneClickLoginUserCheckSuccess,
  getOneClickLoginUserCheckFailure,
  clearOneClickLoginUserCheckResponse,
  getUserAccountLimitCheckLoading,
  getUserAccountLimitCheckSuccess,
  getUserAccountLimitCheckFailure,
  clearUserAccountLimitCheck
} = UserCommonSlice.actions;

export const postUserLoginSignupOtp = (params) => {
  return (dispatch) => {
    dispatch(postUserLoginSignupOtpLoading());
    postLoginSignupOtpRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(postUserLoginSignupOtpSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error) {
          dispatch(postUserLoginSignupOtpFailure(error?.response?.data?.data));
        }
      });
  };
};

export const getUserAuthentication = (params) => {
  return (dispatch) => {
    dispatch(getUserAuthenticationLoading());
    getUserAuthenticationpRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getUserAuthenticationSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getUserAuthenticationFailure(error.response?.data?.data));
        }
      });
  };
};

export const getUserAuthenticationEmail = (params) => {
  return (dispatch) => {
    dispatch(getUserAuthenticationEmailLoading());
    getUserAuthenticationpRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getUserAuthenticationEmailSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getUserAuthenticationEmailFailure(error.response?.data?.data));
        }
      });
  };
};

export const getManageContent = (params) => {
  return (dispatch) => {
    dispatch(getManageContentLoading());
    getManageContentRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getManageContentSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getManageContentFailure(error.message));
        }
      });
  };
};

export const getUserIp = () => {
  const controller = new AbortController();
  const signal = controller.signal;
  // Set a timeout to cancel the request after 10 seconds
  const timeoutId = setTimeout(() => controller.abort(), 5000);
  return (dispatch) => {
    dispatch(getUserIpLoading());
    getIpAddressRepo(signal)
      .then((response) => {
        if (!response || !response.ok) {
          throw new Error("Request failed");
        }
        return response.json(); // Parse response as JSON
      })
      .then((data) => {
        if (data && data.ip) {
          dispatch(getUserIpSuccess(data));
        } else {
          dispatch(getUserIpFailure("Invalid IP response"));
        }
      })
      .catch((error) => {
        // Every failure path must dispatch, otherwise consumers waiting on
        // `userIp || userIpError` stay pending forever. Firefox private mode
        // blocks api.ipify.org via tracking protection and rejects with a plain
        // TypeError, which has no `error.response` and is not an AbortError.
        if (error?.name === "AbortError") {
          dispatch(getUserIpFailure("Request timed out"));
        } else {
          dispatch(getUserIpFailure(error?.message || "Request failed"));
        }
      })
      .finally(() => {
        clearTimeout(timeoutId); // Clear the timeout however the request settles
      });
  };
};

export const getGeolocationData = (params) => {
  return (dispatch) => {
    dispatch(getGeoLocationLoading());
    getGeoLocationRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getGeoLocationSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getGeoLocationFailure(error.message));
        }
      });
  };
};

export const getGpsLocationData = (params) => {
  return (dispatch) => {
    dispatch(getGpsLocationLoading());
     getGpsLocationRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getGpsLocationSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getGpsLocationFailure(error.response?.data?.data || error.message));
        } else if (error) {
          dispatch(getGpsLocationFailure(error.message));
        }
      });
  };
};

export const postLoginData = (data) => {
  return (dispatch) => {
    dispatch(postLoginDataLoading());
    postLoginDataRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(postLoginDataSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postLoginDataFailure(error.message));
        }
      });
  };
};

export const getCtaMessaging = (params) => {
  return (dispatch) => {
    dispatch(getCtaMessagingLoading());
    getCtaMessagingRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getCtaMessagingSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCtaMessagingFailure(error.message));
        }
      });
  };
};
export const postUpdateProfile = (data) => {

  return (dispatch) => {
    dispatch(postUpdateProfileLoading());
    let updatedParams = { ...data };
    if (!updatedParams.domain_id) {
      const sessionDomainId = sessionStorage.getItem("domain_id");
      if (sessionDomainId) {
        updatedParams.domain_stream_id = parseInt(sessionDomainId);
      }
      const upSessionDomainId = sessionStorage.getItem("up_domain_id");
      if (upSessionDomainId) {
        updatedParams.domain_stream_id = parseInt(upSessionDomainId);
      }
      const collegeDomainId = sessionStorage.getItem("domain_stream_id");
      if(!sessionDomainId && !upSessionDomainId && collegeDomainId){
        updatedParams.domain_stream_id = parseInt(collegeDomainId);
      }
    }
    postUpdateProfileRepo(updatedParams)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(postUpdateProfileSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postUpdateProfileFailure(error.response?.data));
        }else if(error){
          dispatch(postUpdateProfileFailure(error.message));
        }
      });
  };
};
export const getEmailDomainData = (params) => {
  return (dispatch) => {
    dispatch(getEmailDomainDataLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getEmailDomainDataSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getEmailDomainDataFailure(error.message));
        }
      });
  };
};

export const getCountryCodeData = (params) => {
  return (dispatch) => {
    dispatch(getCountryCodeDataLoading());
    getSignupFieldsDropdownRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getCountryCodeDataSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(getCountryCodeDataFailure(error.message));
        }
      });
  };
};

export const getUserInfo = (params) => {
  return (dispatch) => {
    dispatch(getUserInfoLoading());
    getUserInfoRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getUserInfoSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error) {
          dispatch(getUserInfoFailure(error?.response?.data?.data));
        }
      });
  };
};

export const postUserProfileClevertap = (data) => {
  return (dispatch) => {
    dispatch(postClevertapUserProfileLoading());
    postUserProfileClevertapRepo(data)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(postClevertapUserProfileSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch(postClevertapUserProfileFailure(error.message));
        }
      });
  };
};

export const getOneClickLoginUserCheck = (params) => {
  return (dispatch) => {
    dispatch(getOneClickLoginUserCheckLoading());
    getOneClickLoginUserCheckRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getOneClickLoginUserCheckSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error) {
          dispatch(getOneClickLoginUserCheckFailure(error?.message));
        }
      });
  };
};
export const getUserAccountLimitCheck = (params) => {
  return (dispatch) => {
    dispatch(getUserAccountLimitCheckLoading());
    getUserAccountLimitRepo(params)
      .then((response) => {
        if (response && response.status == 200) {
          dispatch(getUserAccountLimitCheckSuccess(response?.data?.data));
        }
      })
      .catch((error) => {
        if (error) {
          dispatch(getUserAccountLimitCheckFailure(error?.response?.data?.data));
        }
      });
  };
};


export default UserCommonSlice.reducer;
